import React, { useState } from "react";

// Modules
import { useDispatch, useSelector } from "react-redux";

// App
import { auth_login } from "../../../core/auth";
import { useScreenContext } from "../../../partials/screenContext";

// UI components
import { LockOutlined, PersonOutlineOutlined } from "@mui/icons-material";
import { Button, CircularProgress, FormControl, InputLabel, OutlinedInput, Typography, Alert } from "@mui/material";
import { Col, Row } from "react-bootstrap";

export default function BasicLogin(props) {
  const [isLoading, setLoading] = useState(false);
  const [isError, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  // const [logoutToken, setLogoutToken] = useState("");

  const isInModal = props.type === "modal" ? true : false;
  const { initLogout } = useScreenContext();

  /** redux */
  const user = useSelector((state) => state).authReducer.user;
  const csrf = useSelector((state) => state.csrfTokenReducer);

  /** hooks */
  const dispatch = useDispatch();

  const doLogin = (event) => {
    event.preventDefault();

    if (!username || username === "") {
      setError(true);
      // setErrorMessage(alertMessages.invalidUsername.title);
      return;
    }

    if (!password || password === "") {
      setError(true);
      // setErrorMessage(alertMessages.invalidPassword.title);
      return;
    }

    setLoading(true);
    auth_login(username, password, csrf)
      .then((auth_response) => {
        setLoading(false);
        setError(false);
        setErrorMessage("");
        dispatch({ type: "SAVE_SESSION", payload: auth_response.data });
      })
      .catch((auth_error) => {
        if (auth_error.response?.status === 403) {
          // logout
          initLogout();
        } else {
          let message = "Unknown error!";

          if (auth_error?.response?.data?.message) {
            message = auth_error.response.data.message;
          }

          setLoading(false);
          setError(true);
          setErrorMessage(message);
        }
      });
  };

  return (
    <main className={`login  ${isInModal ? "mt-5" : "screen d-flex flex-column align-items-center"}`}>
      <Row className="g-0">
        <Col xs={12}>{ }</Col>

        {isError && (
          <>
            {errorMessage === "token" && (
              <Col xs={12} className="mb-4">
                <Alert variant="filled" severity="error">
                  Failed to fetch token. Please try again or contact an administrator!
                </Alert>
              </Col>
            )}

            {errorMessage !== "token" && errorMessage !== "username" && errorMessage !== "password" && (
              <Col xs={12} className="mb-4">
                <Alert variant="filled" severity="error">
                  {errorMessage}
                </Alert>
              </Col>
            )}
          </>
        )}

        <Col xs={12}>
          <form onSubmit={doLogin}>
            <div className="form-group">
              <Row>
                <Col>
                  <FormControl
                    // error={
                    //   isError &&
                    //   errorMessage === alertMessages.invalidUsername.title
                    //     ? true
                    //     : false
                    // }
                    sx={{ width: 1 }}
                  >
                    <InputLabel
                      htmlFor="username"
                      sx={{
                        backgroundColor: "#fff",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "primary.main",
                          fontSize: "16px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <PersonOutlineOutlined
                          sx={{
                            paddingRight: "5px",
                            height: "25px",
                          }}
                        />
                        Username
                      </Typography>
                    </InputLabel>
                    <OutlinedInput
                      id={"username"}
                      value={username}
                      onInput={(e) => {
                        setUsername(e.target.value);
                        setError(false);
                        setErrorMessage("");
                      }}
                    />
                    {/* {isError &&
                      errorMessage === alertMessages.invalidUsername.title && (
                        <FormHelperText
                          sx={{ marginLeft: 0 }}
                          id="username-text"
                        >
                          {errorMessage}
                        </FormHelperText>
                      )} */}
                  </FormControl>
                </Col>
              </Row>
            </div>

            <div className="form-group mt-3">
              <Row>
                <Col>
                  <FormControl
                    // error={
                    //   isError &&
                    //   errorMessage === alertMessages.invalidPassword.title
                    //     ? true
                    //     : false
                    // }
                    sx={{ width: 1 }}
                  >
                    <InputLabel htmlFor="password" sx={{ backgroundColor: "#fff" }}>
                      <Typography
                        sx={{
                          color: "primary.main",
                          fontSize: "16px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <LockOutlined
                          sx={{
                            paddingRight: "5px",
                            height: "25px",
                          }}
                        />
                        Password
                      </Typography>
                    </InputLabel>
                    <OutlinedInput
                      type="password"
                      id={"password"}
                      value={password}
                      onInput={(e) => {
                        setPassword(e.target.value);
                        setError(false);
                        setErrorMessage("");
                      }}
                    />
                    {/* {isError &&
                      errorMessage === alertMessages.invalidPassword.title && (
                        <FormHelperText
                          sx={{ marginLeft: 0 }}
                          id="password-text"
                        >
                          {errorMessage}
                        </FormHelperText>
                      )} */}
                  </FormControl>
                </Col>
              </Row>
            </div>

            <div className="form-group mt-5 mb-3">
              <Row>
                <Col className="d-flex justify-content-center">
                  {isLoading ? (
                    <CircularProgress />
                  ) : (
                    <Button
                      sx={{
                        minWidth: "250px",
                      }}
                      variant="contained"
                      type="submit"
                    >
                      Login
                    </Button>
                  )}
                </Col>
              </Row>
            </div>
          </form>
        </Col>
      </Row>
    </main>
  );
}
